module.exports = __webpack_public_path__ + "img/asuaire_logo.ffbb786b.svg";